
import { ThumbUpIcon, EyeIcon } from "@vue-hero-icons/outline";
const CoreDebounceButton = () =>
  import("~~/_core/collections/components/elements/button/DebounceButton.vue");

export default {
  fetchOnServer: false,

  components: { ThumbUpIcon, EyeIcon, CoreDebounceButton },

  props: {
    plan: {
      type: Object,
      default: () => {},
    },
  },

  async fetch() {
    await this.getRegisterPlan();
  },

  data() {
    return {
      userPlan: null,
    };
  },

  computed: {
    customer() {
      return this.$get(this.$$users, "user", "");
    },

    currentSubscription() {
      return this.$$subscriptions || {};
    },

    activePlan() {
      return this.$get(this.currentSubscription, "status") === 'active';
    },

    subcribeText() {
      // if (this.activePlan) {
      //   return this.$t("common.active");
      // }
      return "Subscribe"; // this.$t("common.register");
    },
  },

  methods: {
    async getRegisterPlan() {
      if (!this.customer && !this.userPlan) return;

      const { data: userData } = await this.$axios.get(
        `/api/users/${this.customer.id}/`
      );

      this.userPlan = userData;
    },

    async handleCheckout() {
      try {
        // Call your Django API
        const response = await this.$axios.request({
          url: "/api/polar/create-checkout/",
          method: "POST",
          data: {
            plan_type: this.plan.slug,
            product_id: this.plan.id,
            discount_id: this.plan.discount_id,
          },
        });

        // Redirect to Polar's hosted/custom checkout page
        if (response && response.data && response.data.url) {
          window.location.href = response.data.url;
        }
      } catch (error) {
        console.error("Checkout failed:", error);
      }
    },

    // Currently support plan monthly, 6 months, yearly
    async subscribe() {
      if (!this.customer) {
        this.$router.push("/login");
        return;
      }

      await this.handleCheckout();

      // const { data } = await this.$axios.request({
      //   url: "/api/user/subscribe/",
      //   method: "post",
      //   data: {
      //     planId: this.planId,
      //   },
      // });

      // if (data) {
      //  await this.getRegisterPlan();
      // Redirect to page successfull register,
      // Information to payment, tpbank, etc.
      // Lien he trong vong 24h
      // User can access this page later to see information
      // this.$toast.open({
      //   message: "Chúng tôi sẽ liên hệ với bạn trong vòng 24h!",
      // });
      //  this.$router.push("/mem/info");
      //}
    },
  },
};
